<template>
    <div class="content">
        <div id="print">
            <title>打印出货单</title>
            <div style=" position: relative;z-index: 1;margin-bottom:-10px;">
                <div style="bottom:0; right:2%;width: 20%;height: 110px;position: absolute;z-index: 3;text-align: center;">
                    <div id="qrcode" style="width: 90px;height: 90px;margin:auto;">
                    </div>
                    <div style="margin-top:4px;">
                        {{stock_out_sn}}
                    </div>
                </div>
                <h1 style="text-align: center;margin-bottom: 20px !important;margin-top: 20px;font-weight: bold;font-size: 26px">出库单</h1>
                <div style="color: #666;font-size: 13px;margin-top: 40px;margin-bottom: 20px">
                <div style="padding-bottom:5px;">
                    出货日期：<span style="color: #d9534f;margin-right: 30px">{{stock_out_time}}</span>
                </div>
                <div style="padding-bottom:5px;">
                    客户名称：<span style="color: #d9534f;margin-right: 30px">{{to_name}}</span>
                </div>
                <div >
                    收货地址：<span style="color: #d9534f;margin-right: 30px">{{to_address}}</span>
                </div>
                </div>
            </div>
            <div class="table-container">
                <table width="100%" cellpadding="0" cellspacing="0" border="0" style=" border-collapse: collapse;">
                    <thead>
                    <tr>
                        <th style="color: #333;height: 20px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">序号</th>
                        <th style="color: #333;height: 20px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">产品编号</th>
                        <th style="color: #333;height: 20px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">产品名称</th>
                        <th style="color: #333;height: 40px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">规格</th>
                        <th style="color: #333;height: 20px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">数量</th>
                        <th style="color: #333;height: 20px;border: 1px solid #ccc;background: #caddf2;font-weight: normal;">包装类型</th>
                    </tr>

                    </thead>
                    <tbody>
                    <tr v-for="(item,index)  in data">
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">{{index+1}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">{{item.product_sn}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">{{item.product_name}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">{{item.product_specs}}</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">
                            {{brand_id == "10000042" ? item.stock_out_num : item.real_stock_out_num}}
                        </td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">{{item.product_unit}}</td>
                    </tr>
                    <tr>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;">备注</td>
                        <td style=" text-align: center;font-size: 12px;word-break: break-all;padding: 8px;border: 1px #dbdbdb solid;height: 10px;" colspan="5">{{remarks?remarks:order_notes}}</td>
                        <img v-show="seal_img" style="position: absolute;right:2%;z-index: 4;width:82px;height:82px;" :style="{top:seal_ind+'%'}" :src="seal_img"/>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div style="position: absolute;-webkit-transform: translateX(-50%);-moz-transform: translateX(-50%);-ms-transform: translateX(-50%);-o-transform: translateX(-50%);
        transform: translateX(-50%);left:50%;margin-top: 20px">
            <el-button size="mini" @click="myPrint()">打印</el-button>
            <el-button size="mini" @click="close()">关闭</el-button>
        </div>

    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "print-deliver",
        data() {
            return {
                data:[],
                stock_out_sn:'',
                stock_out_time:'',
                remarks:"",
                order_notes:"",
                to_name: "",
                to_address: "",
                brand_id: "",
                seal_ind:0,
                seal_img:""
            }
        },
        methods: {
            //请求数据获得数据（不从列表页面传）；
            getData(){
                this.$get('logistics','/outwarehouses', {
                    stock_out_sn:this.$route.query.stock_out_sn
                }).then(res => {
                    this.data = res.data[0].outwarehouse_products;
                    this.stock_out_time = res.data[0].stock_out_time;
                    this.remarks=res.data[0].remarks
                    this.order_notes=res.data[0].order_notes
                    this.to_name=res.data[0].to_name
                    this.brand_id=res.data[0].brand_id
                    this.to_address=res.data[0].to_address
                    this.seal_ind=this.data.length*7;
                    //console.log(this.data);
                }).catch(function () {
                });
            },
            //打印
            myPrint() {
                let obj = document.getElementById('print');
                var newWindow = window.open("打印窗口", "_blank");
                var docStr = '<html><head><title>打印内容</title>';
                docStr += '<style>';
                docStr += '.table-container { position: relative; }';
                docStr += 'table { width: 100%; border-collapse: collapse; }';
                docStr += 'td { border: 1px solid #ccc; padding: 8px; }';
                docStr += '</style></head><body>';
                docStr += obj.innerHTML;
                docStr += '</body></html>';
                newWindow.document.write(docStr);
                newWindow.document.close();
                newWindow.print();
                newWindow.close();
            },
            //返回上一页
            close(){
                this.$router.push({
                    name:'deliverManage'
                });
            },
            //二维码
            //扫码
            qrcode () {
                //document.getElementById("qrcode").innerHTML = "";
                let qrcode = new QRCode('qrcode', {
                    width: 90,
                    height: 90, // 高度
                    text:  this.$route.query.stock_out_sn //二维码内容
                })
            },
            //获取公司印章img
            getSeal(){
                this.$get('pda','seal', {
                    lang:'',
                }).then(res => {
                     this.seal_img = res.data.img_url;
                }).catch(function (error) {
                    console.log(error);
                });
            },
        },
        created() {
            this.getData();
            this.$nextTick(function () {
                this.stock_out_sn = this.$route.query.stock_out_sn;
                this.qrcode();
            });
            this.getSeal();
        },
    }
</script>

<style lang="scss" scoped>
    .container {
        padding: 20px;
        position: relative;
    }
    .table-container {
        position: relative;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    td {
        border: 1px solid #ccc;
        padding: 8px;
    }
</style>